import {Color as OriginColor} from "kvweb-ui"
import { useState, useEffect } from "react"
import { useAdminMerchantContext } from "../../contexts/adminMerchant/adminMerchant.context"
import { BRAND_TYPE_KEIVI } from "../constant"

const getCustomColor = () => {
  const isKeivi = localStorage.getItem("isKeivi") || String(window.location.search.includes("is_keivi=true"))

  return {
    ...OriginColor,
    "primary-600": isKeivi === "true" ?  "#CC4A08" : "#005AC3",
    "primary-500": isKeivi === "true" ?  "#FF5C0A" : "#0070F4",
    "primary-400": isKeivi === "true" ?  "#FF7D3B" : "#3378E1",
    "primary-100": isKeivi === "true" ?  "#FFDECE" : "#CCE2FD",
    "primary-50": isKeivi === "true" ?  "#FFEFE6" : "#E5F1FE",
    "primary-25": isKeivi === "true" ?  "#FFF7F3" : "#F2F8FE",
  }
}

// Hook để sử dụng CustomColor với realtime updates
export const useCustomColor = () => {
  const [customColor, setCustomColor] = useState(getCustomColor())
  const { retail } = useAdminMerchantContext();

  useEffect(() => {
    const handleStorageChange = () => {
      setCustomColor(getCustomColor())
    }

    // Listen for storage events
    window.addEventListener('storage', handleStorageChange)

    // Custom event listener for localStorage changes within the same tab
    const originalSetItem = localStorage.setItem
    const originalRemoveItem = localStorage.removeItem

    localStorage.setItem = function(key, value) {
      originalSetItem.apply(this, [key, value])
      if (key === 'isKeivi') {
        window.dispatchEvent(new Event('localStorageChange'))
      }
    }

    localStorage.removeItem = function(key) {
      if (retail?.merchantInfo?.brand_type !== BRAND_TYPE_KEIVI) {
        originalRemoveItem.apply(this, [key])
        if (key === 'isKeivi') {
          window.dispatchEvent(new Event('localStorageChange'))
        }
      }
    }

    window.addEventListener('localStorageChange', handleStorageChange)

    return () => {
      window.removeEventListener('storage', handleStorageChange)
      window.removeEventListener('localStorageChange', handleStorageChange)
      localStorage.setItem = originalSetItem
      localStorage.removeItem = originalRemoveItem
    }
  }, [retail])

  return customColor
}

// Export function để có thể gọi và lấy giá trị mới nhất
export const getCustomColorFn = getCustomColor

// Export object tĩnh để tương thích với code cũ (fallback)
const CustomColor = getCustomColor()

export default CustomColor
